import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=12123e55"
import script from "./Standard.vue?vue&type=script&lang=js"
export * from "./Standard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12123e55')) {
      api.createRecord('12123e55', component.options)
    } else {
      api.reload('12123e55', component.options)
    }
    module.hot.accept("./Standard.vue?vue&type=template&id=12123e55", function () {
      api.rerender('12123e55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/layouts/Standard.vue"
export default component.exports